import $ from "jquery";
import { spIsBase64, spBase64Decode } from '../utilities/utilities';

$(window).on('message', function(e) {

    var data = e.originalEvent.data;

    if (typeof data === 'object' && 'formModalIframe' === data.type)
    {
        var iframe = $(data.id ? '#' + data.id : 'iframe[src="' + data.url + '"]'),
            modal = iframe.closest('.modal');

        console.groupCollapsed('Iframe Message');
        console.log(data);
        console.groupEnd();

        if (iframe.length > 0 && modal.length > 0)
        {
            var formModal = modal.data('tenxFormModal');

            if (data.initiated)
            {
                //formModal.sendAnalytics('formLoaded');
            }
            else if (data.resize)
            {
                modal[0].tenxFormModal.resize();
            }
            else if (data.submitting)
            {
                //$('body').addClass('modal-loading');
                modal.addClass('loading submitting');

                if (modal[0].tenxFormModal.o.skipThankYou)
                {
                    modal.addClass('submitting-no-thank-you');
                }
            }
            else if (data.submitted)
            {
                modal.addClass('submitted');
                formModal.submittedCallback();
                formModal.sendAnalytics('formSubmitted');

                if (formModal.o.skipThankYou)
                {
                    modal[0].tenxFormModal.close();
                    tenxResetFormModals();
                }
                else
                {
                    formModal.closingTimeout = setTimeout(function() {
                        modal[0].tenxFormModal.close();
                        tenxResetFormModals();
                    }, 3500);
                }
            }
        }
        else
        {
            if (data.resize)
            {
                var resizer = iframe.data('iFrameResizer');

                if (resizer)
                {
                    resizer.resize();
                }
            }
        }
    }
});

/*
 *
 */
var tenxResetFormModals = function () {

    $('.modal').each(function() {

        var iframe = $(this).find('iframe');

        if (iframe.length > 0)
        {
            var src = iframe.attr('src');

            if (src)
            {
                iframe.attr('src', src);
            }
        }
    });
};

/*
 *
 */
var tenxFormModal = function(options)
{
    var _t = this;

    this.o = $.extend({
        url             : '',
        urlParams       : null,
        id              : '',
        heading         : '',
        content         : '',
        iframeMinHeight : 400,
        skipThankYou    : false,
        trafficSource   : true
    }, options);

    this.el = {};

    this.init();

    return this;
};

/*
 * Init
 */
tenxFormModal.prototype.init = function()
{
    var _t = this;

    $(window).on('error', function (e) {

        if (e.originalEvent && e.originalEvent.message.indexOf('This error can be disabled by setting the checkOrigin:') > -1)
        {
            if (_t.el.iframe.height() < _t.o.iframeMinHeight)
            {
                _t.el.iframe.height(_t.o.iframeMinHeight);
            }
        }
    });

    this.initModal();
    this.initIframe();

    if (this.o.open)
    {
        //$('body').addClass('modal-loading');
        _t.open();
    }
};


tenxFormModal.prototype.getUrl = function()
{
    var url = this.o.url,
        params = {}, //this.o.trafficSource && STIMPACK.tenxTrafficSource ? STIMPACK.tenxTrafficSource : {},
        paramString = '',
        keys,
        el;

    if (this.o.urlParams)
    {
        params = Object.assign(params, this.o.urlParams);
    }

    if (Object.keys(params).length > 0)
    {
        keys = Object.keys(params);

        for (var i = 0; i < keys.length; i++)
        {
            var value = params[keys[i]];

            if (value.match(/[#.>]/i))
            {
                el = $(value);

                if (el.length > 0)
                {
                    value = el.val();
                }
            }

            paramString += '&' + keys[i] + '=' + value;
        }

        paramString = encodeURI(paramString);

        url += this.o.url.indexOf('?') > -1 ? paramString : paramString.replace('&', '?');
    }

    return url;
}
/*
 * Init
 */
tenxFormModal.prototype.initModal = function()
{
    var _t = this;

    this.closingTimeout = 0;

    this.el.modal = '<div id="form-modal-' + this.o.id.replace(/_/g, '-') + '" class="modal loading" tabindex="-1" role="dialog" aria-hidden="true">' +

    '<div class="modal-backdrop"></div>' +
    '<div class="modal-loading-indicator"><div><div><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"><g transform="translate(-119 -479)"><g stroke="#ffffff" stroke-width="2px" fill="none" transform="translate(119 479)"><circle stroke="none" cx="15" cy="15" r="15"/><circle fill="none" cx="15" cy="15" r="14"/></g><g transform="translate(2 -2)"><g stroke="#ffffff" stroke-width="2px" fill="#ffffff" transform="translate(126 489)"><circle stroke="none" cx="3.5" cy="3.5" r="3.5"/><circle fill="none" cx="3.5" cy="3.5" r="2.5"/></g><g stroke="#ffffff" stroke-width="2px" fill="#ffffff" transform="translate(129 498)"><circle stroke="none" cx="2.5" cy="2.5" r="2.5"/><circle fill="none" cx="2.5" cy="2.5" r="1.5"/></g><g stroke="#ffffff" stroke-width="2px" fill="#ffffff" transform="translate(135 494)"><circle stroke="none" cx="2" cy="2" r="2"/><circle fill="none" cx="2" cy="2" r="1"/></g></g></g></svg></div></div></div>' +

    '<div class="modal-inner">' +
    '<div class="modal-container">' +

    '<div class="modal-dialog modal-lg" role="document">' +
    '<div class="modal-dialog-inner">';

    if (this.o.heading)
    {
        this.el.modal += '<h3 class="text-center text-primary pb-lg mb-lg">' + this.o.heading + '</h3>';
    }

    if (this.o.content)
    {
        this.el.modal += '<div class="text-center pdt-md">' + this.o.content + '</div>';
    }

    this.el.modal += '<div class="modal-body">' +
    '<div class="form-modal-body">' +
    '</div>' +
    '</div>';

    this.el.modal += '</div>' +
    '<button type="button" class="btn modal-close" data-dismiss="modal"></button>' +
    '</div>' +
    '</div>' +

    '</div>' +

    '</div>';

    this.el.modal = $(this.el.modal);

    this.el.modal[0].tenxFormModal = this;

    // ------------------------------------------------------------------ //

    this.el.modal.find('.modal-close, .modal-backdrop').on('click', function() {
        _t.close();
    });

    this.el.modal.on('hidden.bs.modal', function () {

        clearTimeout(this.closingTimeout);

        if (_t.el.modal.hasClass('submitted'))
        {
            _t.el.modal.removeClass('submitted');
            _t.el.iframe.attr('src', _t.el.iframe.attr('src'));
        }
    });

    // ------------------------------------------------------------------ //

    $('body').append(this.el.modal);
    this.el.modal.data('tenxFormModal', this);
};

/*
 * Init
 */
tenxFormModal.prototype.initIframe = function()
{
    var _t = this;

    this.el.iframe = $('<iframe id="form-modal-' + this.o.id.replace(/_/g, '-')  + '-iframe" src="" type="text/html" frameborder="0" allowTransparency="true" scrolling=”no”></iframe>');

    this.el.iframe.on('load', function(e) {

        _t.el.iframe.height('auto');
        _t.el.iframe.resizer.resize();

        setTimeout(function() {

            _t.el.iframe.resizer.resize();

            setTimeout(function() {

                //repositionModal(_t.el.modal);

                //$('body').removeClass('modal-loading');
                _t.el.modal.removeClass('loading submitting');
                _t.el.modal.addClass('loaded');

                if (_t.o.skipThankYou)
                {
                    setTimeout(function() {
                        _t.el.modal.removeClass('submitting-no-thank-you');
                    }, 1000);
                }

            }, 200);

        }, 100);
    });

    this.el.modal.find('.form-modal-body').append(this.el.iframe);
    this.el.iframe.attr('src', this.getUrl());

    this.el.resizableIframes = window.iFrameResize({
        heightCalculationMethod : 'max',
        checkOrigin             : [
            'https://www.10xgenomics.com',
            'https://pages.10xgenomics.com',
            'https://go.10xgenomics.com',
            'https://pi.pardot.com',
            'https://tenxstaging.wpengine.com',
            'https://na-ab37.marketo.com',
            'https://na-ab39.marketo.com'
        ],
        resizedCallback         : function(data) {
            //repositionModal(_t.el.modal);
        }
    }, this.el.iframe[0]);

    this.el.iframe.resizer = this.el.resizableIframes[0].iFrameResizer;
};

/*
 * Resize
 */
tenxFormModal.prototype.resize = function()
{
    this.el.iframe.height('auto');
    this.el.iframe.resizer.resize();
};

/*
 * Open
 */
tenxFormModal.prototype.open = function()
{
    this.el.modal.addClass('active');
    $('body').addClass('modal-active');
};

/*
 * Open
 */
tenxFormModal.prototype.close = function()
{
    this.el.modal.removeClass('active');
    $('body').removeClass('modal-active')
};


/*
 * Analytics
 */
tenxFormModal.prototype.submittedCallback = function()
{
    if (this.o.onSubmitted)
    {
        this.o.onSubmitted.call(this, this);
    }
};

/*
 * Analytics
 */
tenxFormModal.prototype.sendAnalytics = function(event)
{

};

$.fn.tenxFormModal = function(options)
{
    return this.each(function() {

        this.tenxFormModal = new tenxFormModal(options);
    });
};


$('[data-form-modal]').each(function() {

    var trigger = $(this),
        options = trigger.data('form-modal');

    if (spIsBase64(options))
    {
        options = JSON.parse(atob(options));
    }

    var id = '#form-modal-' + options.id.replace(/_/g, '-');

    trigger.attr('data-form-modal', '1');

    trigger.on('click', function(e) {

        var modal = $(id);

        e.preventDefault();

        if (modal.length > 0)
        {
            modal[0].tenxFormModal.open();
        }
        else
        {
            options.open = true;
            new tenxFormModal(options);
        }
    });
});
